export var GOOGLE_MAPS_API_KEY = 'AIzaSyB83oLNUmqes7wBlxqQ7yQbXuF-K5faJb4';